<template>
  <div id="app">
    <div class="swp-calculator">
      <div class="row">
        <div class="col-lg-12">
          <div class="card swp-border">
            <div class="card-body">
              <v-form @submit.prevent="submitForm">
                <div class="row">
                  <div class="col-md-6">
                    <div class="swp-input">
                      <label for="total-investment" class="label-spacing"
                        >Total investment</label
                      >
                      <span class="swp-group">
                        <div class="rupees-symbol">₹</div>
                        <input
                          type="text"
                          class="form-control"
                          v-model="formData.totalInvestment"
                          outlined
                          id="total-investment"
                        />
                      </span>
                    </div>
                    <div class="swp-input">
                      <label for="monthly-withdrawal" class="label-spacing"
                        >Withdrawal per month</label
                      >
                      <span class="swp-group">
                        <div class="rupees-symbol">₹</div>
                        <input
                          type="text"
                          class="form-control"
                          v-model="formData.withdrawalPerMonth"
                          outlined
                          id="monthly-withdrawal"
                        />
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="swp-input">
                      <label for="expected-return" class="label-spacing"
                        >Expected return rate (P.A.)</label
                      >
                      <span class="swp-group">
                        <button
                          type="button"
                          aria-label="Expected return rate (P.A.) decrement"
                          @click="decreaseReturns"
                        >
                          -
                        </button>
                        <input
                          class="form-control text-center"
                          type="text"
                          v-model="formData.expectedReturnRate"
                          outlined
                          id="expected-return"
                        />
                        <button
                          type="button"
                          aria-label="Expected return rate (P.A.) increment"
                          @click="increaseReturns"
                        >
                          +
                        </button>
                      </span>
                    </div>
                    <div class="swp-input">
                      <label for="inflation-rate" class="label-spacing"
                        >Inflation rate (%)</label
                      >
                      <span class="swp-group">
                        <button
                          type="button"
                          aria-label="Inflation rate (%) decrement"
                          @click="decreaseInflation"
                        >
                          -
                        </button>
                        <input
                          type="text"
                          v-model="formData.inflationRate"
                          class="form-control text-center"
                          outlined
                          id="inflation-rate"
                        />
                        <button
                          type="button"
                          aria-label="Inflation rate (%) increment"
                          @click="increaseInflation"
                        >
                          +
                        </button>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="swp-input">
                      <label for="time-period" class="label-spacing"
                        >Time period (Years)</label
                      >
                      <span class="swp-group py-1">
                        <button
                          type="button"
                          aria-label="Time period (Years) decrement"
                          @click="decreaseTimePeriod"
                        >
                          -
                        </button>
                        <input
                          class="form-control text-center"
                          type="text"
                          v-model="formData.timePeriod"
                          outlined
                          id="time-period"
                        />
                        <button
                          type="button"
                          aria-label="Time period (Years) increment"
                          @click="increaseTimePeriod"
                        >
                          +
                        </button>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3" style="align-content: end">
                    <div class="form-group mt-4">
                      <button
                        type="button"
                        @click="submitForm()"
                        style="
                          width: 100%;
                          background: #00a3d9;
                          color: white;
                          padding: 0.7em;
                          margin: 0px 0 12px;
                        "
                        class="btn"
                      >
                        Calculate
                      </button>
                    </div>
                  </div>
                </div>
              </v-form>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div
            class="sr-only"
            role="status"
            aria-live="polite"
            aria-atomic="true"
          >
            {{ resultsAnnouncement }}
          </div>
          <div class="second-card">
            <div class="row">
              <div class="col-md-4">
                <div class="card swp-border-card">
                  <div class="card-body swp-card-color">
                    <div class="text-center">
                      <label for="result-total-investment" class="swp-card-label"
                        >Total investment</label
                      >
                    </div>
                    <div
                      class="text-center"
                      aria-live="polite"
                      aria-atomic="true"
                    >
                      <input
                        v-model="formattedTotalInvestment"
                        class="swp-card-input"
                        id="result-total-investment"
                        aria-label="Total investment value"
                        readonly
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card swp-border-card">
                  <div class="card-body swp-card-color">
                    <div class="text-center">
                      <label for="result-total-withdrawal" class="swp-card-label"
                        >Total withdrawal</label
                      >
                    </div>
                    <div
                      class="text-center"
                      aria-live="polite"
                      aria-atomic="true"
                    >
                      <input
                        v-model="formattedTotalWithdrawal"
                        class="swp-card-input"
                        id="result-total-withdrawal"
                        aria-label="Total withdrawal value"
                        readonly
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card swp-border-card">
                  <div
                    :class="
                      finalValue < 0
                        ? 'card-body negativeResult'
                        : 'card-body positiveresult'
                    "
                  >
                    <div class="text-center">
                      <label for="result-final-value">Final value</label>
                    </div>
                    <div
                      class="text-center"
                      aria-live="polite"
                      aria-atomic="true"
                    >
                      <div>
                        <input
                          v-if="finalValue !== null"
                          v-model="formattedFinalValue"
                          class="swp-card-input"
                          id="result-final-value"
                          aria-label="Final value"
                          readonly
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="finalValue < 0"
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
                style="display: block; text-align: center"
              >
                <span class="swp-icon fst-italic">
                  <i class="fa fa-times-circle-o" aria-hidden="true"></i>
                  <small style=""
                    >Your investment amount does not support the withdrawal
                    rate. You may have to reduce your withdrawal or increase
                    your investment</small
                  >
                </span>
              </div>
              <i class="swp-disclaim"
                >Disclaimer: Results shown for illustrative purpose only and
                should not be construed as investment advice</i
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SWPCalculator",
  components: {},
  data() {
    return {
      formData: {
        totalInvestment: 500000,
        withdrawalPerMonth: 5000,
        expectedReturnRate: "12 %",
        timePeriod: "5 years",
        inflationRate: "3.5 %",
      },
      finalValue: "2,88,185",
      totalInterest: 0,
      totalInvest: "5,00,000",
      totalWithdrawal: "3,21,748",
      resultsAnnouncement: "",
    };
  },
  computed: {
    formattedFinalValue() {
      return `₹ ${this.finalValue.toLocaleString("en-IN")}`;
    },
    formattedTotalInterest() {
      return `₹ ${this.totalInterest.toLocaleString("en-IN")}`;
    },
    formattedTotalInvestment() {
      return `₹ ${this.totalInvest.toLocaleString("en-IN")}`;
    },
    formattedTotalWithdrawal() {
      return `₹ ${this.totalWithdrawal.toLocaleString("en-IN")}`;
    },
  },
  methods: {
    submitForm() {
      this.calculateSWP();
    },
    calculateSWP() {
      const totalInvestmentValue = parseFloat(this.formData.totalInvestment);
      let withdrawalAmountValue = parseFloat(this.formData.withdrawalPerMonth);
      const expectedReturnsValue =
        parseFloat(this.formData.expectedReturnRate) / 100;
      const tenureValue = parseFloat(this.formData.timePeriod);
      const inflationRate = parseFloat(this.formData.inflationRate) / 100;
      const monthsPerYear = 12;
      let tlwithdraw = 0;
      const monthlyReturnRate = 1 + expectedReturnsValue / 12;
      let remainingInvestmentValue = totalInvestmentValue;
      this.totalInvest = totalInvestmentValue;
      for (let month = 1; month <= tenureValue * monthsPerYear; month++) {
        if (
          month % monthsPerYear === 0 &&
          month !== tenureValue * monthsPerYear
        ) {
          // Do something if needed here
        } else if (month > monthsPerYear && (month - 1) % monthsPerYear === 0) {
          withdrawalAmountValue *= 1 + inflationRate;
        }
        remainingInvestmentValue -= withdrawalAmountValue;
        remainingInvestmentValue *= monthlyReturnRate;
        tlwithdraw += withdrawalAmountValue;
        console.log(tlwithdraw);
      }

      const finalValueWithInflation = Math.round(remainingInvestmentValue);
      this.finalValue = finalValueWithInflation;
      this.totalWithdrawal = Math.round(tlwithdraw);
      this.announceResults();
    },
    announceResults() {
      let message = `Calculation complete. Total investment: ${this.formattedTotalInvestment}. Total withdrawal: ${this.formattedTotalWithdrawal}. Final value: ${this.formattedFinalValue}.`;

      if (this.finalValue < 0) {
        message +=
          " Your investment amount does not support the withdrawal rate. You may have to reduce your withdrawal or increase your investment.";
      }

      this.resultsAnnouncement = "";
      this.$nextTick(() => {
        this.resultsAnnouncement = message;
      });
    },

    increaseReturns() {
      const numericValue = parseFloat(this.formData.expectedReturnRate);
      if (numericValue < 5.5) {
        this.formData.expectedReturnRate = `${Math.min(
          numericValue + 0.5,
          5.5
        )} %`;
      } else if (numericValue < 50) {
        this.formData.expectedReturnRate = `${numericValue + 0.5} %`;
      }
    },
    decreaseReturns() {
      const numericValue = parseFloat(this.formData.expectedReturnRate);
      if (numericValue <= 5.5) {
        if (numericValue > 5) {
          this.formData.expectedReturnRate = `${Math.max(
            numericValue - 0.5,
            5
          )} %`;
        }
      } else {
        this.formData.expectedReturnRate = `${numericValue - 0.5} %`;
      }
    },
    increaseInflation() {
      const numericValue = parseFloat(this.formData.inflationRate);
      if (numericValue < 3.5) {
        this.formData.inflationRate = `${Math.min(numericValue + 0.5, 3.5)} %`;
      } else if (numericValue < 20) {
        this.formData.inflationRate = `${numericValue + 0.5} %`;
      }
    },
    decreaseInflation() {
      const numericValue = parseFloat(this.formData.inflationRate);
      if (numericValue <= 3.5) {
        if (numericValue > 3) {
          this.formData.inflationRate = `${Math.max(numericValue - 0.5, 3)} %`;
        }
      } else {
        this.formData.inflationRate = `${numericValue - 0.5} %`;
      }
    },
    increaseTimePeriod() {
      const numericValue = parseFloat(this.formData.timePeriod);
      if (numericValue < 50) {
        this.formData.timePeriod = `${numericValue + 1} years`;
      }
    },
    decreaseTimePeriod() {
      const numericValue = parseFloat(this.formData.timePeriod);
      if (numericValue > 1) {
        this.formData.timePeriod = `${numericValue - 1} years`;
      }
    },
  },
};
</script>

<style scoped>
.swp-calculator .swp-input label {
  display: block;
  font-weight: bold;
  text-align: justify;
  font-size: 16px;
  color: #012e40 !important;
}

.swp-input input {
  text-align: justify;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent;
}

.swp-input input:focus-visible {
  /* Restores a visible keyboard focus indicator (Tab) */
  outline: 3px solid #000000 !important;
  outline-offset: 2px;
  border-radius: 6px;
}

.swp-calculator .swp-input button {
  background: transparent;
  border: none;
  color: #000000;
}

.swp-calculator .swp-input button:focus-visible {
  /* Buttons also have outline removed elsewhere, so add an explicit ring */
  outline: 3px solid #000000 !important;
  outline-offset: 2px;
  border-radius: 6px;
}

.swp-calculator .calculatecta {
  width: 100%;
  background: #00a3d9;
  color: white;
}

.swp-group {
  display: flex;
  border: 1px solid #e5e5e5;
  margin: 0 0 10px;
  border-radius: 8px;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;
}

.label-spacing {
  margin-bottom: 0.7rem;
  display: flex;
}

.swp-border {
  border: none;
  outline: none;
  background: none;
}

.swp-card input {
  border: none;
  outline: none;
  background: none;
  flex: 1;
  text-align: right;
}

.swp-card input:focus-visible {
  /* Readonly summary inputs can be focusable via Tab */
  outline: 3px solid #000000 !important;
  outline-offset: 2px;
  border-radius: 6px;
}

.swp-calculator {
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
  padding: 1%;
}

.second-card {
  border: none !important;
  border-radius: 10px;
  padding: inherit;
  margin-top: -36px;
}

.second-card .swp-card {
  display: flex;
  align-items: center;
  padding: 5px;
}

.swp-card label {
  flex: 1;
}

.rupees-symbol {
  display: flex;
  font-size: 14px;
  color: #555;
  margin: 10px;
}

.years-label {
  position: absolute;
  margin-left: 50% !important;
  top: 50%;
  transform: translateY(-50%);
}

.percent-label {
  position: absolute;
  margin-left: 53% !important;
  top: 50%;
  transform: translateY(-50%);
}

.swp-border-card {
  border: none;
}

.swp-card-color {
  background: #f8f9fa;
  border-radius: 10px;
}

.swp-card-label {
  font-weight: bold;
  text-align: center;
}

.swp-card-input {
  text-align: center;
  border: none;
  outline: none;
  background: transparent;
}

.swp-icon {
  margin-top: -16px;
}
.swp-icon i {
  color: red;
}
.positiveresult {
  background: rgba(56, 226, 178, 0.2);
  border-radius: 10px;
}
.positiveresult label {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #012e40;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
}
.positiveresult input {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #012e40;
  text-shadow: 3px 3px 8px rgba(0, 255, 87, 0.25);
  border: none;
  text-align: center;
  background: none;
}
.negativeResult {
  background: rgba(226, 56, 56, 0.2);
  border-radius: 10px;
}
.negativeResult label {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #012e40;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
}
.negativeResult input {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #dd2e44;
  text-shadow: 3px 3px 8px rgba(255, 0, 0, 0.25);
  border: none;
  text-align: center;
  background: none;
}

.swp-disclaim {
  color: #918d99;
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 12px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
